module.exports = __webpack_public_path__ + "29e053c926e3a6e5d7b2314afa50365e.svg";